// WMD-1251: Strict normalization for the two per-sector metric fields that
// come off the ingest payload — the column direction (X/O) and the P&F
// signal (Buy/Sell). Any recognizable value (case-insensitive,
// whitespace-tolerant) becomes its canonical form; anything else — empty,
// null, unexpected token — becomes the neutral '---'.
//
// This replaces the historical `raw === 'o' ? 'O' : 'X'` pattern that silently
// fell back to 'X' on any non-'O' input, which downstream became a spurious
// "BUY NOW" label whenever the server field was missing or malformed. See the
// WMD-1251 ticket for the failure mode.
//
// Consumers that treat '---' as unknown will render '---' in the UI; consumers
// that check `col === 'X'` or `col === 'O'` will simply see false for both
// branches (i.e. "not this direction") which is the correct semantics for
// unknown data.

export type ColumnDirection = 'X' | 'O' | '---';
export type Signal = 'Buy' | 'Sell' | '---';

function invariant( raw: string | null | undefined ): string {
    return raw?.trim().toLowerCase() ?? '';
}

export function normalizeColumn( raw: string | null | undefined ): ColumnDirection {
    const value = invariant( raw );
    if ( value === 'x' ) return 'X';
    if ( value === 'o' ) return 'O';
    return '---';
}

export function normalizeSignal( raw: string | null | undefined ): Signal {
    const value = invariant( raw );
    if ( value === 'buy' ) return 'Buy';
    if ( value === 'sell' ) return 'Sell';
    return '---';
}
